module.exports = __webpack_public_path__ + "img/laravel-vue-banner.5e59d41f.png";